<template>
  <button
    type="button"
    class="rounded-full px-4 border border-white text-white p-2 rounded leading-none flex items-center"
  >
    <slot></slot>
  </button>
</template>

<script></script>

<style scoped></style>
